// React component

import { motion } from "framer-motion";
import { ReactNode } from "react";
import { useMaintenance } from "@/context/MaintenanceContext";
import { useLocation } from "react-router-dom";

interface MaintenanceWrapperProps {
  children: ReactNode;
}

export const MaintenanceWrapper = ({ children }: MaintenanceWrapperProps) => {
  const { isInMaintenance } = useMaintenance();
  const location = useLocation();
  const pathname = location.pathname;
  const isDevelopmentPage = pathname.includes("development");

  if (!isDevelopmentPage) {
    return <>{children}</>;
  }

  return (
    <motion.div
      animate={{
        filter: isInMaintenance ? "blur(8px)" : "blur(0px)",
        pointerEvents: isInMaintenance ? "none" : "auto",
      }}
      transition={{ duration: 0.5 }}
      className="relative"
      data-oid="fqm1j.:"
    >
      {children}
    </motion.div>
  );
};

export default MaintenanceWrapper;
